<template>
  <div class="ndetails">
    <div class="details litigation-details">
      <Other ref='Other' :info='OtherInfo' :isOther='true' @resh='init' />
      <His ref='His' :info='HisInfo' @resh='init' />
      <Lawsuit ref='Lawsuit' :info='LawsuitInfo' @resh='init' :letters_debtor='letterPeo' />
      <AddDislog ref="AddDislog" :info='deInfo' @resh='init'></AddDislog>
      <a-spin :spinning="loading">
        <div class="maindetails">
          <div class="card wbg">
            <div class="htit">
              <div class="h2">债务人信息</div>
              <div class="rt">
                <a-button type="primary" icon="edit" style='margin:0 20px;'
                  @click="editdeInfo(debInfo.debtor);">修改</a-button>
                <a-popconfirm title="确认删除该债务人吗?" ok-text="确定" cancel-text="取消" @confirm='del(debInfo.debtor.id, 1)'>
                  <a-button type="danger" icon="delete">删除</a-button>
                </a-popconfirm>
              </div>
            </div>
            <div class="nselectbox">
              <a-row type='flex' style="margin-bottom:20px;">
                <a-col :span='4'>
                  <label>姓名：</label>
                  <span>{{ debInfo.debtor.realname }}</span>
                </a-col>
                <a-col :span='4'>
                  <label>证件号码：</label>
                  <span style="white-space:normap;">{{ debInfo.debtor.chinaid }}</span>
                </a-col>
                <a-col :span='2'>
                  <label>性别：</label>
                  <span>{{ debInfo.debtor.sex | tosex }}</span>
                </a-col>
                <a-col :span='4'>
                  <label>联系方式：</label>
                  <span>{{ debInfo.debtor.phone }}</span>
                </a-col>
                <a-col :span='10'>
                  <label>户籍所在地：</label>
                  <span>{{ debInfo.debtor.address }}</span>
                </a-col>
              </a-row>
              <a-row>
                <label>备注：</label>
                <span>{{ debInfo.debtor.comment }}</span>
              </a-row>
            </div>
          </div>
          <div class="card wbg">
            <div class="htit">
              <div class="h2">其他债务人信息</div>
              <div class="rt">
                <a-button type="primary" ghost icon="plus" @click='OtherInfo = {}; visibleShow("Other");'>新增</a-button>
              </div>
            </div>
            <div class="tableList" v-if='debInfo.relevance_debtor.length > 0'>
              <div class="table">
                <table>
                  <thead>
                    <td width='78'>姓名</td>
                    <td width='120'>证件号码</td>
                    <td width='94'>联系方式</td>
                    <td width='40'>性别</td>
                    <td width='200'>户籍所在地</td>
                    <td width='60'>操作</td>
                  </thead>
                  <tbody>
                    <tr v-for='(i, index) in debInfo.relevance_debtor' :key='i.id'>
                      <td>{{ i.realname }}</td>
                      <td>{{ i.chinaid }}</td>
                      <td>{{ i.phone }}</td>
                      <td>{{ i.sex | tosex }}</td>
                      <td>
                        <Normap :tit='i.address'></Normap>
                      </td>
                      <td>
                        <a href="javascript:void(0);" @click='visibleShow("Other"); OtherInfo = clone(i);'>修改</a>
                        <span class="line"></span>
                        <a-popconfirm title="确认删除此条数据吗?" ok-text="确定" cancel-text="取消" @confirm='del(i.id)'>
                          <a href="javascript:void(0);" style="color:#f00;">删除</a>
                        </a-popconfirm>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <div class="card wbg">
            <div class="htit">
              <div class="h2">函件信息</div>
              <div class="rt">
                <a-button type="primary" ghost icon="plus" @click="LawsuitInfo = {}; visibleShow('Lawsuit')"
                  v-if="$common.AccAUTH(nowAccId, 'letters:view:add')">新增</a-button>
                <a-button type="primary" icon="edit"
                  v-if="debInfo.letters.length > 0 && $common.AccAUTH(nowAccId, 'letters:view:edit')"
                  style='margin:0 20px;'
                  @click="LawsuitInfo = debInfo.letters[cur]; visibleShow('Lawsuit')">修改</a-button>
                <a-popconfirm title="确认删除此条数据吗?" ok-text="确定" cancel-text="取消" @confirm='delLetter(LawsuitInfo.id)'
                  v-if="debInfo.letters.length > 0 && $common.AccAUTH(nowAccId, 'letters:view:del')">
                  <a-button type="danger" icon="delete">删除</a-button>
                </a-popconfirm>
              </div>
            </div>
            <div class="inset" v-if="$common.AccAUTH(nowAccId, 'letters:view:index')">
              <div class='tab'>
                <a href='javascript:void(0);' v-for='(i, index) in debInfo.letters'
                  @click='cur = index; LawsuitInfo = i;' :class='{ "cur": cur == index }'>函件{{ index + 1 }}</a>
              </div>
              <div class='cmains' v-if='debInfo.letters.length > 0'>
                <a-row>
                  <a-col :span='5'> <label>函件类型：</label><span>{{ LaInfo.letters_type | rName }}</span></a-col>
                  <a-col :span='5'> <label>函件名称：</label><span>{{ LaInfo.title }}</span></a-col>
                  <a-col :span='5'> <label>函号：</label><span>{{ LaInfo.no }}</span></a-col>
                  <a-col :span='5'> <label>委托人：</label><span>{{ LaInfo.accuser.title }}</span></a-col>
                  <a-col :span='4'>
                    <label>接收人：</label><span>{{ LaInfo.receiver ? LaInfo.receiver.realname : '' }}</span></a-col>
                </a-row>
                <div class="mhtit2">邮寄信息</div>
                <div class="ibox">
                  <a-row style='margin-bottom:20px;'>
                    <a-col :span='6'> <label>单号：</label><span>{{ LaInfo.ship_no }}</span></a-col>
                    <a-col :span='6'> <label>材料名称：</label><span>{{ LaInfo.filename }}</span></a-col>
                    <a-col :span='6'> <label>联系方式：</label><span>{{ LaInfo.tel }}</span></a-col>
                    <a-col :span='6'> <label>收件人：</label><span>{{ LaInfo.receive_name }}</span></a-col>
                  </a-row>
                  <a-row style='margin-bottom:20px;'>
                    <a-col :span='12'> <label>收件地址：</label><span>{{ LaInfo.addr }}</span></a-col>
                    <a-col :span='6'> <label>寄出时间：</label><span>{{ LaInfo.ship_time }}</span></a-col>
                    <a-col :span='6'>
                      <label>签收情况：</label><span>{{ shipType(LaInfo.receive_time, LaInfo.return_time) }}</span></a-col>
                  </a-row>
                  <a-row>
                    <a-col :span='24'> <label>备注：</label><span>{{ LaInfo.comment }}</span></a-col>
                  </a-row>
                </div>
                <div class="filelist">
                  <div class="title">
                    <span>附件</span>
                  </div>
                  <div class="list">
                    <!-- <a class='i' v-for='i in LaInfo.files' href="javascript:void(0);" @click='see(i)'>{{i.origin_name}}</a> -->
                    <FileList ref="FileList" :list="LaInfo.files"></FileList>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="card wbg">
            <div class="htit" style="border:0 none;">
              <div class="h3">案件沟通记录 </div>
              <div class="rt">
                <a-button type="primary" ghost icon="plus" @click='HisInfo = {}; visibleShow("His")'>添加</a-button>
              </div>
            </div>
            <div class="ntable table" v-if='comList.length > 0'>
              <table cellpadding="0" cellspacing="0">
                <thead>
                  <td width='50'>序号</td>
                  <td width='100'>时间</td>
                  <td width='60'>沟通方式</td>
                  <td width='80'>联系方式</td>
                  <td width='80'>我方人员</td>
                  <td width='80'>对方人员</td>
                  <td width='260'>沟通内容</td>
                  <td width='90'>操作</td>
                </thead>
                <tbody>
                  <tr v-for='(j, ind) in comList' :key='j.id'>
                    <td>{{ ind + 1 }}</td>
                    <td style="white-space: nowrap;">{{ j.create_time }}</td>
                    <td>{{ j.type | rtype }}</td>
                    <td>
                      <Normap :tit='j.tel'></Normap>
                    </td>
                    <td>
                      <Normap :tit='j.uname'></Normap>
                    </td>
                    <td>
                      <Normap :tit='j.adversary'></Normap>
                    </td>
                    <td>
                      <Normap :tit='j.content' v-if='j.content'></Normap>
                    </td>
                    <td>
                      <a href='javascript:void(0);' @click='j.see = true; HisInfo = j; visibleShow("His");'>查看</a>
                      <a href='javascript:void(0);' @click='j.see = false; HisInfo = j; visibleShow("His");'> <span
                          class="line"></span>修改</a>
                      <a-popconfirm title="确认删除此条数据吗?" ok-text="确定" cancel-text="取消" @confirm='delcomment(j.id)'>
                        <a href="javascript:void(0);" style="color:#f00;"> <span class="line"></span>删除</a>
                      </a-popconfirm>
                    </td>
                  </tr>
                </tbody>
              </table>
              <div class="pages" v-if='comment.total > 5'>
                <a-pagination v-model="comment.page" show-quick-jumper :total="comment.total" show-less-items
                  :pageSize='5' @change='(e) => { comment.page = e }' />
              </div>
            </div>
          </div>
        </div>
      </a-spin>
    </div>
  </div>
</template>
<script>
import Other from './add'
import His from './his'
import Lawsuit from './lawsuit'
import AddDislog from './add'
import { Ldebtor, letters, LHis } from '@/server/api'
import { rName, deInfoKeys } from './keys'
import FileList from './fileList.vue'

function clone(list) {
  return JSON.parse(JSON.stringify(list))
}
export default {
  components: {
    Other, His, Lawsuit, AddDislog, FileList
  },
  data() {
    return {
      cur: 0,
      debInfo: {
        debtor: {},
        relevance_debtor: {},
        letters: [],
        comment: []
      },
      comment: {
        page: 1,
        limit: 5,
        total: 0,
      },
      deInfo: {},
      fileInfo: {},
      LawsuitInfo: {},   //当前诉讼
      HisInfo: {},     //当前沟通记录
      OtherInfo: {}, //单个其他债务人详情
      loading: true, //加载
    }
  },
  filters: {
    rName,
    rtype(val) {
      if (val) {
        const typelist = [
          { name: "未选择", value: 0 },
          { name: "现场", value: 1 },
          { name: "电话", value: 2 },
          { name: "短信", value: 3 },
          { name: "微信", value: 4 }
        ]
        return typelist[val].name
      }
      else {
        return '未选择'
      }
    },
  },
  computed: {
    LaInfo() {
      if (!this.loading) {
        return clone(this.debInfo.letters[this.cur])
      } else {
        return {}
      }
    },
    comList() {
      let slist = JSON.parse(JSON.stringify(this.debInfo.comment))
      if (this.comment.page == 1) {
        return slist.filter((ele, index) => { return index < 5 })
      } else {
        return slist.filter((ele, index) => { return index >= (this.comment.page - 1) * 5 && index < this.comment.page * 5 })
      }
    },
    letterPeo() {
      if (this.debInfo.debtor.realname) {
        return [...[{ id: this.$route.params.id * 1, name: this.debInfo.debtor.realname }], ...this.debInfo.relevance_debtor.map(ele => { return { name: ele.realname, id: ele.id * 1 } })]
      }
    },
    nowAccId() {
      if (this.debInfo.letters.length > 0) {
        return this.debInfo.letters[this.cur].accuser_id
      } else {
        return this.debInfo.debtor.accuser_id
      }
    }
  },
  created() {
    this.init()
  },
  methods: {
    clone,
    editdeInfo(e) {
      const info = clone(e)
      let form = {}
      deInfoKeys.map(ele => {
        form[ele] = info[ele]
      })
      this.deInfo = form
      this.visibleShow('AddDislog')
    },
    shipType(receive_time, return_time) {
      if (!receive_time && !return_time) {
        return '无'
      } else {
        if (receive_time) {
          return '签收/' + receive_time
        } else {
          return '拒收/' + return_time
        }
      }
    },
    init() {
      this.cur = 0
      Ldebtor('info', {
        id: this.$route.params.id
      }).then(e => {
        this.debInfo = e
        this.LawsuitInfo = e.letters[0]
        this.comment.total = e.comment.length
        this.loading = false;
      })
    },
    visibleShow(name) {
      this.$refs[name].visible = true;
    },
    delLetter(id) {
      Ldebtor('del', { letters_id: id }).then(e => {
        this.$message.success('删除成功')
        this.init()
      })
    },
    delcomment(id) {
      LHis('del', { comment_id: id }).then(e => {
        this.comment.page = 1;
        this.$message.success('删除成功')
        this.init()
      })
    },
    del(id, type) {
      letters('del', { debtor_id: id }).then(e => {
        this.$message.success('删除成功')
        this.$router.push({ name: "letters" });
        // this.init()
      })
    }
  }
}
</script>
<style lang="less">
.tab-wrap {
  .ant-tabs-bar {
    margin-left: 20px;
  }
}

.ising {
  opacity: 0.3;
}

@import '../ly/index.less';
</style>
<style lang='less' scoped>
.inset {
  padding: 0 20px 20px;

  .tab {
    padding: 14px 0 20px;

    a {
      margin-right: 40px;
      font-size: 14px;
      color: #0E2949;
      line-height: 20px;
    }

    .cur {
      color: #1D8BFE;
    }
  }

  .cmains {
    background: #F6F8FC;
    padding: 20px;
    font-size: 14px;
    color: #66707C;
    line-height: 20px;

    label {
      font-weight: 500;
      color: #0E2949;
    }

    .mhtit2 {
      padding: 20px 0 10px;
      font-weight: bold;
      color: #0E2949;
    }

    .ibox {
      margin-bottom: 20px;
      padding: 20px;
      border: 1px solid #DADADA;
    }

    .filelist {
      overflow: hidden;

      .title {
        margin-bottom: 10px;

        span {
          font-weight: bold;
          color: #0E2949;
          padding-right: 5px;
        }


      }

      .list {
        display: flex;
        flex-wrap: wrap;

        .i {
          color: #66707C;
          transition-duration: 500ms;
          position: relative;
          padding-right: 10px;

          &::after {
            content: '';
            display: block;
            position: absolute;
            right: 0;
            width: 1px;
            height: 10px;
            border: 1px solid #DADADA;
            top: 8px;
          }

          &:nth-last-child(1) {
            &::after {
              display: none;
            }
          }

          margin-right:10px;

          &:hover {
            color: #1D8BFE;
          }
        }
      }
    }
  }
}
</style>